import {
  STANDS_PENDING,
  STANDS_FAILED,
  STANDS_DOWNLOADED,
  STANDS_RESET,
  STAND_SENDING,
  STAND_DOWNLOADED,
} from './types';
import StandsApiService from '../../services/api/StandsApiService';
import { handleError } from '../infos/actions';

export const standsResetAction = () => ({
  type: STANDS_RESET,
});

export const standSendingAction = () => ({
  type: STAND_SENDING,
});

export const standDownloadedAction = (site) => ({
  type: STAND_DOWNLOADED,
  payload: site,
});

export const standsDownloadedAction = (sites) => ({
  type: STANDS_DOWNLOADED,
  payload: sites,
});

export const standsFailedAction = (error) => ({
  type: STANDS_FAILED,
  payload: error,
});

export const standsPendingAction = () => ({
  type: STANDS_PENDING,
});

export function resetStands() {
  return (dispatch) => {
    dispatch(standsResetAction());
  };
}

export function getStands(authUserToken, role) {
  return (dispatch) => {
    dispatch(standsPendingAction());
    return StandsApiService
      .getStands(authUserToken, role)
      .then((data) => {
        dispatch(standsDownloadedAction(data));
      })
      .catch((error) => {
        dispatch(standsFailedAction(error));
        dispatch(handleError(error));
      });
  };
}

export function postStand(authUserToken, siteId, stand) {
  return (dispatch) => {
    dispatch(standSendingAction());
    return StandsApiService
      .postAdminStands(authUserToken, { site_id: siteId, ...stand })
      .then((data) => {
        dispatch(standDownloadedAction(data));
      })
      .catch((error) => {
        dispatch(standsFailedAction(error));
        dispatch(handleError(error));
      });
  };
}

export function putStand(authUserToken, standId, stand) {
  return (dispatch) => {
    dispatch(standSendingAction());
    return StandsApiService
      .putStands(authUserToken, standId, stand)
      .then((data) => {
        dispatch(standDownloadedAction(data));
      })
      .catch((error) => {
        dispatch(standsFailedAction(error));
        dispatch(handleError(error));
      });
  };
}



// WEBPACK FOOTER //
// ./src/store/stands/actions.js